module.exports = __webpack_public_path__ + "img/African-common.46a1d92f.jpg";